<style lang="scss" src="./App.scss" />
<template>
  <div class="app">
    <router-view />
    <div class="loading" v-if="isLoading">
      <i class="fas fa-spinner fa-spin" />
    </div>
    <div class="popup" v-if="popupVisible && fueraDeHorario">
      <div class="popup__content">
        <i class="fa fa-exclamation-triangle" />
        <span v-html="popupMessage"></span>
        SI TIENES ALGUNA DUDA LLAMANOS AL TELEFONO:
        <a
          href="tel:0034937632635"
          class="btn btn-info btn-lg btn-block"
        >+34 937 632 635</a>
        <span class="btn-close" @click="popupVisible = false">
          <i class="fa fa-times" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import firebase from "firebase";
import { usersRef } from "./firebase";

export default {
  data() {
    return {
      popupMessage: "",
      popupVisible: true,
      isLoading: true
    };
  },
  computed: {
    fueraDeHorario() {
      const format = "hh:mm:ss";

      const time = moment();

      const diaSemana = time.isoWeekday();

      if (diaSemana === 27) {
        this.popupMessage = `
            HOY NO TENEMOS ABIERTO,<br>
            SI DESEAS HACER TU PEDIDO AHORA, INDICANOS EN EL <br>
            CUADRO DE OBSERVACIONES A QUE HORA QUIERES QUE TE ENTREGUEMOS<br>
            TU PEDIDO. GRACIAS Y DISCULPA LAS MOLESTIAS.<br>
        `;
        return true;
      } else {
        const horaInicio = diaSemana === 6 ? "08:30:00" : "07:30:00";
        const horaFin = diaSemana === 6 ? "13:30:00" : "15:30:00";
        const beforeTime = moment(horaInicio, format);
        const afterTime = moment(horaFin, format);

        /* if (time.isBetween(beforeTime, afterTime)) {
          return false
        } else {
          this.popupMessage = `
            HOY NUESTRO HORARIO DE ATENCIÓN AL CLIENTE ES DE <br> 
            <h1 style="margin:0"><code>
            ${horaInicio.slice(0, -3)} a 
            ${horaFin.slice(0, -3)}</code></h1> <br>
            SI DESEAS HACER TU PEDIDO AHORA, INDICANOS EN EL <br>
            CUADRO DE OBSERVACIONES A QUE HORA QUIERES QUE TE ENTREGUEMOS<br>
            TU PEDIDO. GRACIAS Y DISCULPA LAS MOLESTIAS.<br>
          `
          return true
        } */
      }
    }
  },
  created() {
    this.isLoading = true;
    firebase
      .auth()
      .getRedirectResult()
      .then(result => {
        if (result.user || firebase.auth().currentUser) {
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
    firebase.auth().onAuthStateChanged(async user => {
      if (user && user.uid) {
        usersRef.child(user.uid).once("value", p => {
          if (!p.val()) {
            let profile = {
              uid: user.uid,
              email: user.email,
              displayName: user.displayName,
              photoURL: user.photoURL
            };
            usersRef
              .child(user.uid)
              .child("user")
              .set(profile);
            this.$store.commit("setUserProfile", profile);
            this.isLoading = false;
          } else {
            this.$store.commit("setUserProfile", p.val());
            this.isLoading = false;
          }
        });
        usersRef.child(user.uid).on("value", snap => {
          this.$store.commit("setUserProfile", snap.val());
        });
      } else {
        this.$store.commit("setUserProfile");
      }
    });
  },
  methods: {
    userProcess(user) {
      //// console.log('userProcess.user', user)
      if (user && user.uid) {
        usersRef.child(user.uid).once("value", p => {
          const value = p.val();
          if (!value) {
            let profile = {
              uid: user.uid,
              email: user.email || "",
              displayName: user.displayName || "",
              phone: user.phone || "",
              photoURL: user.photoURL || ""
            };
            usersRef
              .child(user.uid)
              .child("user")
              .set(profile);
            this.$store.commit("setUserProfile", profile);
          } else {
            this.$store.commit("setUserProfile", value);
          }
        });
        /* usersRef.child(user.uid).on('value', snap => {
          this.$store.commit('setUserProfile', snap.val())
        }) */
      } else {
        this.$store.commit("setUserProfile");
      }
    }
  }
};
</script>
